import React, {ReactElement} from 'react';
import SwitchDiagram from '../SwitchDiagram/SwitchDiagram';
import SwitchAccordian from '../components/SwitchAccordian';
import {SwitchStackData} from '../interfaces/SwitchConnectivityState';
import {PortHistoryState, PortHistorySwitchStack} from '../interfaces/PortHistoryState';
import {useSwitchStacksAccordionState} from 'features/SwitchConnectivity/SwitchStack/SwitchStacksAccordionState';

const renderSwitchDiagrams = (
  switchStack: SwitchStackData,
  portHistorySwitchStack: PortHistorySwitchStack | null
): ReactElement[] => {
  const switchDiagrams: ReactElement[] = [];

  switchStack.memberSwitches.forEach(switchItem => {
    const {switchNumber, mainPorts} = switchItem;
    const portHistorySwitch = portHistorySwitchStack?.switches[switchNumber] ?? null;

    switchDiagrams.push(
      <SwitchDiagram
        key={switchNumber}
        ports={mainPorts}
        switchNumber={switchNumber}
        portHistorySwitch={portHistorySwitch}
      />
    );
  });

  return switchDiagrams;
};

export default function SwitchDiagramContainer({
  switchStackName,
  switchStacks,
  anchorIDPrefix,
  portHistoryData,
}: {
  switchStackName: string;
  switchStacks: SwitchStackData[];
  anchorIDPrefix: string;
  portHistoryData: PortHistoryState;
}) {
  const {
    state: switchStacksAccordionsState,
    dispatch: reactDispatch,
  } = useSwitchStacksAccordionState();

  const switchStack = switchStacks.find(device => switchStackName === device.switchStackName)!;
  const isExpanded = switchStacksAccordionsState.get(switchStackName)!.diagram;

  const handleAccordianChange = (switchStack: string): void => {
    reactDispatch({
      type: 'TOGGLE_SWITCH_STACK_ACCORDION',
      payload: {switchStack, view: 'diagram'},
    });
  };

  const SwitchDiagrams = renderSwitchDiagrams(
    switchStack,
    portHistoryData.switchStacks[switchStack.switchStackName] ?? null
  );

  return (
    <SwitchAccordian
      key={`${anchorIDPrefix}${switchStack}`}
      header={switchStack.switchStackName}
      anchorId={switchStack.switchStackName}
      isExpanded={isExpanded}
      handleAccordianChange={handleAccordianChange}
    >
      {SwitchDiagrams}
    </SwitchAccordian>
  );
}
